import Fuse from 'fuse.js';

type fuseReturn<T> = (tArray: T[]) => { data: T[]; fuse: Fuse<T> };

export function fuse<T>(searchOptions: Fuse.IFuseOptions<T>): fuseReturn<T> {
  return (tArray: T[]) => {
    return fuseWithOptions(tArray, searchOptions);
  };
}

function fuseWithOptions<T>(tArray: T[], searchOptions: Fuse.IFuseOptions<T>) {
  return {
    data: tArray,
    fuse: new Fuse(tArray, searchOptions),
  };
}
